import { render, staticRenderFns } from "./edit-profile.vue?vue&type=template&id=28ee5b2c&scoped=true"
import script from "./edit-profile.vue?vue&type=script&setup=true&lang=js"
export * from "./edit-profile.vue?vue&type=script&setup=true&lang=js"
import style0 from "./edit-profile.vue?vue&type=style&index=0&id=28ee5b2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ee5b2c",
  null
  
)

export default component.exports